import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "shareButton", "toggleDropdownButton", "inputLink", "linkWrapper" ]

  showAndCopyShareLink(event) {
    event.preventDefault();
    this.linkWrapperTarget.classList.remove('d-none');
    this.inputLinkTarget.focus();
    this.inputLinkTarget.select();
    document.execCommand("copy");
    var toggleDropdownButton = this.toggleDropdownButtonTarget
    var linkWrapper = this.linkWrapperTarget
    setTimeout(function(){
      toggleDropdownButton.classList.remove('show');
    }, 100);
    setTimeout(function(){
      linkWrapper.classList.add('d-none');
    }, 5000);
  }

  toggleDropdown() {
    this.linkWrapperTarget.classList.add('d-none');
  }
}
